export default __webpack_public_path__ + "static/media/gallery_04.bc931d6d.jpg";